import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Logo } from "../components/site/Logo";
import { MailCheck } from "lucide-react";

export default function PasswordDimenticata() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Si è verificato un errore. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-6" data-testid="forgot-page">
      <div className="w-full max-w-md">
        <Logo />
        {sent ? (
          <div data-testid="forgot-sent" className="mt-8 rounded-2xl border border-emerald-200 bg-emerald-50 p-6">
            <MailCheck className="h-8 w-8 text-[#10B981]" />
            <h1 className="mt-4 font-display text-2xl font-bold text-[#0A192F]">Controlla la tua email</h1>
            <p className="mt-2 text-sm text-slate-600">
              Se l'indirizzo è registrato, riceverai a breve un'email con le istruzioni per reimpostare la password. Il link è valido per 60 minuti e può essere usato una sola volta.
            </p>
            <Link to="/login" data-testid="forgot-back-login" className="mt-6 inline-block font-semibold text-[#10B981]">← Torna all'accesso</Link>
          </div>
        ) : (
          <>
            <h1 className="mt-8 font-display text-3xl font-bold text-[#0A192F]">Password dimenticata?</h1>
            <p className="mt-2 text-slate-600">Inserisci la tua email: ti invieremo un link per reimpostare la password.</p>

            {error && <div data-testid="forgot-error" className="mt-6 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>}

            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="mb-2 block text-sm font-semibold text-[#0A192F]">Email</label>
                <input data-testid="forgot-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-xl border border-slate-200 px-4 py-3 outline-none focus:ring-2 focus:ring-[#10B981]" />
              </div>
              <button data-testid="forgot-submit" disabled={loading} className="w-full rounded-full bg-[#10B981] px-8 py-3.5 font-semibold text-white transition-colors hover:bg-[#059669] disabled:opacity-60">
                {loading ? "Invio in corso..." : "Invia il link di reimpostazione"}
              </button>
            </form>

            <p className="mt-6 text-center text-sm">
              <Link to="/login" className="text-slate-400 hover:text-[#0A192F]">← Torna all'accesso</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
